import { Translation } from 'src/types';

export enum SITE_TYPE {
    PUBLIC = 'public',
    PRIVATE = 'private',
    COMMERCIAL = 'commercial',
    RESIDENTIAL = 'residential',
}

export enum COUNTRY_MAP {
    BG = 'BG',
}

export type Site = {
    id: string;
    coordinates: {
        type: 'Point';
        coordinates: [number, number];
    };
    translations: SiteTranslation[];
    created_at: string;
    modified_at: string;
    total_spaces: number;
    floors: number;
    country: COUNTRY_MAP;
    type: SITE_TYPE;
    is_24_7: boolean;
    service_provider: {
        id: string;
        name: string;
    };
};

export interface SiteTranslation extends Translation {
    id: string;
    created_at: string;
    modified_at: string;
    address: string;
    city: string;
}
